export default "__VITE_ASSET__DWi$PHs0__"